module.exports = {"430211001":"嵩山路街道","430211002":"泰山路街道","430211003":"栗雨街道","430211101":"群丰镇","430211102":"雷打石镇","430211103":"三门镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430211.json
// module id = 1664
// module chunks = 0